import { applyAuth0Theme } from "@/utils/theme/themeEngine";

import MfaSmsList from "./components/MfaSmsList";
import MfaSmsListHeader from "./components/MfaSmsListHeader";
import { useMfaSmsListManager } from "./hooks/useMfaSmsListManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function MfaSmsListScreen() {
    // Extracting attributes from hook made out of MfaSmsList instance of Auth0 React ACUL SDK
    const { mfasmsList, texts, locales } = useMfaSmsListManager();

    applyAuth0Theme(mfasmsList);
    return (
        <AuthLayout title={texts?.pageTitle || locales?.page?.title}>

            <MfaSmsListHeader />
            <MfaSmsList />

        </AuthLayout>
    );
}

export default MfaSmsListScreen;
